// Firebase
import { storage } from '@breakroom-nx/apis';
import { ref, getDownloadURL } from 'firebase/storage';

export async function getAvatarURL(path: string): Promise<string | undefined> {
  const response = await getDownloadURL(ref(storage, path))
    .then((url) => {
      return url;
    })
    .catch((error) => {
      // console.log(`${error.code}: ${error.message}`);
      return undefined;
    });

  return response;
}
